// MSAL-Browser-Integration fuer den Entra-spa-Flow (Browser-PKCE, kein Client-Secret).
// Tenant-Restriktion: nur der konfigurierte mindsquare-Tenant (authority).
//
// Genutzt nur wenn /auth/config strategy=entra && mode=spa liefert. Der mode=web-Flow
// laeuft komplett serverseitig (siehe AuthContext.loginEntra -> /auth/login-Redirect).

import { PublicClientApplication } from "@azure/msal-browser";

export interface MsalLoginParams {
  readonly clientId: string;
  readonly tenantId: string;
  /** API-Scope, z.B. api://<client-id>/.default — liefert ein Access-Token fuers Backend. */
  readonly scope: string;
}

let cached: PublicClientApplication | null = null;

async function getInstance(clientId: string, tenantId: string): Promise<PublicClientApplication> {
  if (cached) return cached;
  const pca = new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin,
    },
    cache: { cacheLocation: "sessionStorage" },
  });
  await pca.initialize();
  cached = pca;
  return pca;
}

/**
 * Oeffnet das Microsoft-Login-Popup und liefert ein Access-Token fuer den API-Scope.
 * Popup statt Redirect: in sich geschlossen, kein handleRedirectPromise-Bootstrap noetig.
 */
export async function msalGetToken(params: MsalLoginParams): Promise<string> {
  const pca = await getInstance(params.clientId, params.tenantId);
  const result = await pca.loginPopup({ scopes: [params.scope] });
  if (!result.accessToken) throw new Error("MSAL returned no access token");
  return result.accessToken;
}
